import { render } from "./DefaultViewBatchContainer.vue?vue&type=template&id=bb85ae60&scoped=true"
import script from "./DefaultViewBatchContainer.vue?vue&type=script&lang=js"
export * from "./DefaultViewBatchContainer.vue?vue&type=script&lang=js"

import "./DefaultViewBatchContainer.vue?vue&type=style&index=0&id=bb85ae60&lang=css&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb85ae60"]])

export default __exports__